var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconModelGesture = function SvgIconModelGesture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#icon_model_gesture_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.907 4.497a3.27 3.27 0 0 0-.624-1.724M3.904 1.786c.36-.539.85-.937 1.402-1.18M3.62 13.726l-.395-.45a6.9 6.9 0 0 1-1.27-2.12l-.786-2.097a1.272 1.272 0 0 1 2.356-.957l.664 1.514c.497.133 1.637.652 2.219 1.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.19 9.619 1.665-6.215a1.287 1.287 0 1 1 2.485.666L7.341 7.8l1.399-5.22a1.287 1.287 0 0 1 2.486.666L9.694 8.962l.865-3.231a1.287 1.287 0 1 1 2.486.666l-1.953 7.288a2.29 2.29 0 0 1-1.065 1.388l-.44.254"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_model_gesture_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconModelGesture;